import AxioClient from "@/repositories/Clients/AxioClient";
const resource = '/tickets';

export default {
    getAll() {
        return AxioClient.get(`${resource}`);
    },
    get(id) {
        return AxioClient.get(`${resource}/${id}`);
    },

    // MANY OTHER ENDPOINT RELATED STUFFS
};